import type { ReactNode } from "react";

export const Kbd = ({ children }: { children: ReactNode }) => (
  <kbd className="inline-flex h-5 min-w-[20px] items-center justify-center rounded border border-white/20 bg-white/10 px-1 font-mono text-[10px] text-white/70">
    {children}
  </kbd>
);

interface ActionButtonProps {
  tone: "accept" | "reject";
  disabled: boolean;
  onClick: () => void;
  icon: ReactNode;
  label: string;
  loading?: boolean;
  hint?: string;
}

export const ActionButton = ({
  tone,
  disabled,
  onClick,
  icon,
  label,
  loading,
  hint,
}: ActionButtonProps) => {
  const tones =
    tone === "accept"
      ? "bg-emerald-600 text-white hover:bg-emerald-500 hover:shadow-sm hover:shadow-emerald-600/30"
      : "bg-red-600 text-white hover:bg-red-500 hover:shadow-sm hover:shadow-red-600/30";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={hint}
      className={`group relative flex flex-1 items-center justify-center gap-3 rounded-2xl px-6 py-4 text-base font-semibold transition disabled:cursor-not-allowed disabled:opacity-40 ${tones}`}
    >
      {loading ? (
        <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white" />
      ) : (
        icon
      )}
      <span>{label}</span>
    </button>
  );
};
